<template>
    <nav class="navbar">
        <v-wrapper>
            <v-divider>
                <router-link :to="`${path.toLowerCase()}`" class="navbar__brand">
                    <img :alt="this.$appSettings.appName" src="/img/logo.svg"/>
                </router-link>
                <button
                    @click="$store.commit('modals/modalHandler', { name: 'modalCountry', boolean: true })"
                    class="navbar__country"
                    type="button"
                >
                    {{ country.name }}
                </button>
            </v-divider>
            <v-divider>
                <a class="navbar__publish" href="https://www.mapaprop.com/?ref=118" target="_blank">Publicar</a>
                <v-menu />
            </v-divider>
        </v-wrapper>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            country: 'countries/country',
            path: 'path'
        })
    }
}
</script>

<style lang="scss">
.navbar {
    position: absolute;
    top: 0;
    z-index: 1000;
    left: 0;
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    box-shadow: 0 0 4px 0 rgba(#000000, 0.2);
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__brand {
        margin-right: 1rem;
        img {
            height: 50px;
        }
    }

    &__country {
        height: 30px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        font-size: 0.8rem;
        border-radius: 4px;
        border: 1px solid #e3e3e3;
        background-color: #ffffff;
    }

    &__publish {
        height: 40px;
        margin-right: 1rem;
        padding-left : 1rem;
        padding-right: 1rem;
        display: flex;
        align-items: center;
        border-radius: 4px;
        color: #ffffff;
        background-color: #c9d700;
    }
    @media (max-width: 992px) {
        &__publish {
            display: none;
        }
    }
    @media (max-width: 576px) {
        &__divider {
            position: relative;
            z-index: 2;
            max-width: 100%;
            padding: 0.4rem 0;
            background-color: #ffffff;
        }
    }
}
</style>
